import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';
import { getFormValues } from 'redux-form';

import { ReportGeneration } from 'Common/ObjectHelper';
import { toastType, createToast } from 'Common/ToastHelper';
import { Filter, Main } from 'Containers/';
import { ChecksSummaryReportForm } from './components/ChecksSummaryReportForm';
import { ChecksSummaryReportFieldEnum as Fields } from 'Common/FieldEnum';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { CHECKS_SUMMARY_REPORT_FORM_NAME } from 'Common/FormEnum';
import {
  getChecksSummaryReport,
  clearReport,
} from './state/checkssummaryreport/actions';
import { LoadingPage } from 'Components/loading/LoadingPage';

class ChecksSummaryReportContainer extends Component {
  state = { siteId: 'ALL', reportType: 'TransactionHistory' };

  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: CHECKS_SUMMARY_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: loading,
          disabled: loading,
        },
        shown: true,
      },
    };
  };

  componentDidUpdate(prevProps, prevState) {
    const { report } = this.props;

    if (prevProps.report !== report && report) {
      if (report === 'No Data') {
        createToast(toastType.info, 'Results', 'No data found!', true);
      } else {
        ReportGeneration(report, 'Case Type Report');
      }
      this.props.clearReport();
    }
  }

  handleSubmit = formValues => {
    this.props.getChecksSummaryReport(formValues);
  };

  handleSiteChange = value => {
    this.setState({ siteId: value });
  };

  render() {
    const { formValues } = this.props;
    return (
      <Fragment>
        {this.props.loading ? <LoadingPage /> : undefined}
        <Filter title={'Checks Summary Report'} />
        <Main {...this.getMainProps()}>
          <ChecksSummaryReportForm
            onSubmit={this.handleSubmit}
            onSiteChange={this.handleSiteChange}
            onReportTypeChange={this.handleReportTypeChange}
            initialValues={{
              [Fields.ReportType]: !formValues
                ? 'TransactionHistory'
                : formValues[Fields.ReportType],
              [Fields.SiteId]: this.state.siteId,
              [Fields.FromDate]: defaultDateFormat(moment()),
              [Fields.ToDate]: defaultDateFormat(moment()),
              [Fields.SortBy]: 'StudentNumber',
              [Fields.IsSupper]: false,
            }}
          />
        </Main>
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    loading: state.ChecksSummaryReportState.checksSummaryReport.loading,
    report: state.ChecksSummaryReportState.checksSummaryReport.report,
    formValues: getFormValues(CHECKS_SUMMARY_REPORT_FORM_NAME)(state),
  };
};

export const ChecksSummaryReport = withRouter(
  connect(
    mapStateToProps,
    { getChecksSummaryReport, clearReport }
  )(ChecksSummaryReportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/checkssummaryreport/ChecksSummaryReport.js